<template>
	<div>
		<div class="">
			<!-- Payment Methods -->
			<div class="btn-group-vertical w-100" role="group">
				<draggable
					class="w-100 d-block"
					group="payments"
					handle=".group-item"
					v-model="availablePaymentOptions"
					v-bind="dragOptions"
					@start="drag = true"
					@end="drag = false"
					@change="onPaymentSorted">
					<transition-group
						class="d-block w-100"
						type="transition"
						:name="!drag ? 'flip-list' : null">
						<div
							class="w-100"
							v-for="(payment) in availablePaymentOptions"
							:key="payment.key">
							<div class="flex-center btn btn-default btn-default-light btn-block group-item br-0">
								<label
									class="d-flex align-items-center mb-0 w-100 cur-p">
									<i class="material-icons" v-tooltip="'Drag to reorder'">drag_indicator</i>
									<div class="custom-control custom-checkbox flex-center justify-content-between w-100">
										<input
											type="checkbox"
											class="custom-control-input"
											:value="payment"
											v-model="selectedPayments"
										>
										<span class="custom-control-label">{{ payment.label }}</span>
									</div>
								</label>
								<div class="flex-center">
									<i
										class="material-icons info"
										v-tooltip="payment.info"
										v-if="payment.info"
									>info</i>
									<i
										class="material-icons text-secondary ml-2"
										v-tooltip="'Config'"
										@click.stop="editPaymentDescription(payment)"
										v-if="payment.key !== 'instant'"
									>settings</i>
								</div>
							</div>
							<template v-if="isPaymentSelected(payment)">
								<!-- COD Couriers -->
								<div
									class="well br-0 mb-minus"
									v-if="payment.key === 'cod'">
									<cod-settings
										:couriers.sync="codShippingCouriers"
										:is-smart.sync="shippingSmartMode"
										v-model="codCourier">
									</cod-settings>
								</div>

								<!-- Instant Payments Channels -->
								<div
									class="well br-0 mb-minus"
									v-if="payment.key === 'instant'">
									<div class="cod-settings container-fluid">
										<div class="mt-2 mb-3">
											<b>E-Payment Channels</b>
										</div>
										<payment-channels
											:has-config="true"
											v-bind:descriptions.sync="channelsDescriptions"
											v-model="selectedPaymentChannels"
										/>
										<p class="mt-2">Biaya per transaksi dapat di-check di sini: <a href="https://orderonline.id/epayment/#pricing" target="_blank">Biaya Transaksi</a></p>
									</div>
								</div>
							</template>
						</div>
					</transition-group>
				</draggable>
			</div>
		</div>

		<div class="modals">
			<!-- Payment Method Description -->
			<payment-method-description
				v-if="isPaymentMethodDescriptionVisible && selectedPayment"
				:show="isPaymentMethodDescriptionVisible"
				:selectedPayment="selectedPayment"
				:description="methodsDescriptions[selectedPayment.key]"
				@close="isPaymentMethodDescriptionVisible = false"
				@change="onMethodsDescriptionChange"
			/>
		</div>
	</div>
</template>

<script>
import draggable from 'vuedraggable';
import PaymentChannels from '@/components/PaymentChannels.vue';
import PaymentMethodDescription from '@/components/PaymentMethodDescription.vue';
import CodSettings from '@/components/CodSettings.vue';

import {
	paymentChannels,
	paymentOptions,
	codCouriers,
} from '@/lib/statics';
import {
	duplicateVar,
} from '@/lib/helper';

// bank_transfer: '',
// cod: '',
// instant: '',

export default {
	components: {
		draggable,
		PaymentChannels,
		CodSettings,
		PaymentMethodDescription,
	},
	data: () => ({
		paymentOptions: duplicateVar(paymentOptions),
		selectedPayments: duplicateVar(paymentOptions),
		paymentChannels: duplicateVar(paymentChannels),
		selectedPaymentChannels: ['bca_va', 'credit_card', 'gopay', 'dana', 'alfamart'],
		availablePaymentOptions: [],
		channelsDescriptions: {},
		methodsDescriptions: {},
		selectedPayment: null,
		isPaymentMethodDescriptionVisible: false,
		dragOptions: {
			animation: 100,
		},
		drag: false,
		codShippingCouriers: ['sap'],
		shippingSmartMode: false,
		codCourier: duplicateVar(codCouriers[0]),
	}),
	computed: {
		params() {
			const shippingMode = this.shippingSmartMode ? 'smart' : 'normal';
			const params = {
				payment_channels: this.selectedPaymentChannels, // "[\"credit_card\",\"bca_va\",\"bni_va\",\"gopay\",\"ovo\",\"dana\"]"
				payment_channels_descriptions: this.channelsDescriptions, // "{\"credit_card\":\"Credit card lorem ipsum\"}"
				payment_methods_descriptions: this.methodsDescriptions, // "{\"bank_transfer\":\"lorem ipsum \"}"
				payments: this.selectedPayments, // "[\"bank_transfer\",\"cod\",\"instant\"]"
				shipping: {
					cod: this.codCourier,
					cod_couriers: this.codShippingCouriers,
					mode: shippingMode, // 'normal' / 'smart'
				},
			};

			return params;
		},
	},
	watch: {
		params: {
			deep: true,
			handler() {
				this.onValueChanged();
			},
		},
		// selectedPaymentChannels: {
		// 	deep: true,
		// 	handler() {
		// 		this.onValueChanged();
		// 	}
		// },
	},
	mounted() {
		this.setPayments();
	},
	methods: {
		isPaymentSelected(payment) {
			const index = this.selectedPayments.findIndex(
				({ key }) => key === payment.key,
			);
			return index !== -1;
		},

		setPayments() {
			const options = duplicateVar(this.paymentOptions);
			let payments = this.selectedPayments.map(({ key }) => options.find(option => option.key === key));
			payments = payments.filter(payment => !!payment);
			// Add Disabled Payments
			options.forEach((option) => {
				const index = payments.findIndex(({ key }) => key === option.key);
				const isNotExist = index === -1;
				if (isNotExist) {
					payments.push(option);
				}
			});
			this.availablePaymentOptions = payments;
		},

		editPaymentDescription(payment) {
			this.selectedPayment = payment;
			this.isPaymentMethodDescriptionVisible = true;
		},

		onMethodsDescriptionChange(value) {
			if (this.selectedPayment) {
				const method = this.selectedPayment.key;
				this.$set(this.methodsDescriptions, method, value);
			}
		},
		onPaymentSorted() {
			const selected = this.selectedPayments.map(payment => payment.key);
			const selectedPaymentOptions = this.availablePaymentOptions.filter(
				({ key }) => selected.includes(key),
			);
			this.selectedPayments = selectedPaymentOptions;
		},
		onValueChanged() {
			this.$emit('change', this.params);
		},
	},
};
</script>

<style>

</style>
